import React from "react";
import MachineRow from "./MachineRow";
import Filed from "./Filed";
import { useLocation } from "react-router-dom";
const ColTable = ({data}) => {
  const monthList = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
  const location = useLocation();
  
  return (
    <div className="overflow-y-auto border-gray-400 border-b min-w-full min-h-44 p-3">
      <div className="flex">
        <Filed text={"호기"} style={"bg-blue-400 text-white"} />
        <Filed text={`${location.pathname === '/month' ? "년월" : "지종"}`} style={"bg-blue-400 text-white"} />
        {
          location.pathname === '/month' 
          ? monthList.map((month, index) => {
            return <Filed key={index} text={month} style={"bg-blue-400 text-white"} />
            })
          : data && data.map((v, index) => {
            return <Filed key={index} text={`${v.PKCDXX.replace("원지", "")} ${v.BSSWGH}`} style={"bg-blue-400 text-white"} />
          })
        }
      </div>
      {
        data && 
        data.map((data, index) => {
          return <MachineRow key={index} data={data}/>
        })
      }
    </div>
  )  
}

export default ColTable;